import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=5680a484&scoped=true"
import script from "./PageTitleBar.vue?vue&type=script&lang=ts"
export * from "./PageTitleBar.vue?vue&type=script&lang=ts"
import style0 from "./PageTitleBar.vue?vue&type=style&index=0&id=5680a484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680a484",
  null
  
)

export default component.exports